const _temp0 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/AIGenerate.tsx");
const _temp1 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/AIGenerateImage.tsx");
const _temp2 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/AIchat.tsx");
const _temp3 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Accessibility.tsx");
const _temp4 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Animation.tsx");
const _temp5 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Apps.tsx");
const _temp6 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Artboard.tsx");
const _temp7 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Assets.tsx");
const _temp8 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/AudioWave.tsx");
const _temp9 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/BadgeVerified.tsx");
const _temp10 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Bell.tsx");
const _temp11 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Bolt.tsx");
const _temp12 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Brand.tsx");
const _temp13 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Briefcase.tsx");
const _temp14 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/BrightnessContrast.tsx");
const _temp15 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Browser.tsx");
const _temp16 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Brush.tsx");
const _temp17 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/BuildTable.tsx");
const _temp18 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Buildings.tsx");
const _temp19 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Calendar.tsx");
const _temp20 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Camera.tsx");
const _temp21 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/CardTapPayment.tsx");
const _temp22 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Channel.tsx");
const _temp23 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/ChartAreaStack.tsx");
const _temp24 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Chatbubble.tsx");
const _temp25 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Checkmark.tsx");
const _temp26 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Clipboard.tsx");
const _temp27 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Clock.tsx");
const _temp28 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Cloud.tsx");
const _temp29 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/CloudUpload.tsx");
const _temp30 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/CodeBrackets.tsx");
const _temp31 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Color.tsx");
const _temp32 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/CommentText.tsx");
const _temp33 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Confetti.tsx");
const _temp34 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Conversationbubbles.tsx");
const _temp35 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Crop.tsx");
const _temp36 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Cursor.tsx");
const _temp37 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Cut.tsx");
const _temp38 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Data.tsx");
const _temp39 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/DataAnalytics.tsx");
const _temp40 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Desktop.tsx");
const _temp41 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Diamond.tsx");
const _temp42 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Document.tsx");
const _temp43 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Download.tsx");
const _temp44 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/DropToUpload.tsx");
const _temp45 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Education.tsx");
const _temp46 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Effects.tsx");
const _temp47 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Emoji.tsx");
const _temp48 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/EmptyStateExport.tsx");
const _temp49 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Explosion.tsx");
const _temp50 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/ExportTo.tsx");
const _temp51 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Exposure.tsx");
const _temp52 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FileImage.tsx");
const _temp53 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FileShared.tsx");
const _temp54 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FileText.tsx");
const _temp55 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FileVideo.tsx");
const _temp56 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FileZip.tsx");
const _temp57 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Filmstrip.tsx");
const _temp58 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Filter.tsx");
const _temp59 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Filters.tsx");
const _temp60 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Fireworks.tsx");
const _temp61 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Flag.tsx");
const _temp62 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FlagCheckmark.tsx");
const _temp63 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FlagCross.tsx");
const _temp64 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FolderClose.tsx");
const _temp65 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FolderOpen.tsx");
const _temp66 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/FolderShared.tsx");
const _temp67 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/GearSetting.tsx");
const _temp68 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Gift.tsx");
const _temp69 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/Globe.tsx");
const _temp70 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/GlobeGrid.tsx");
const _temp71 = require("../../../../../@react-spectrum/s2/spectrum-illustrations/gradient/generic1/GraphBarChart.tsx");
module.exports = {
  "IGenerate": _temp0,
  "IGenerateImage": _temp1,
  "Ichat": _temp2,
  "ccessibility": _temp3,
  "nimation": _temp4,
  "pps": _temp5,
  "rtboard": _temp6,
  "ssets": _temp7,
  "udioWave": _temp8,
  "adgeVerified": _temp9,
  "ell": _temp10,
  "olt": _temp11,
  "rand": _temp12,
  "riefcase": _temp13,
  "rightnessContrast": _temp14,
  "rowser": _temp15,
  "rush": _temp16,
  "uildTable": _temp17,
  "uildings": _temp18,
  "alendar": _temp19,
  "amera": _temp20,
  "ardTapPayment": _temp21,
  "hannel": _temp22,
  "hartAreaStack": _temp23,
  "hatbubble": _temp24,
  "heckmark": _temp25,
  "lipboard": _temp26,
  "lock": _temp27,
  "loud": _temp28,
  "loudUpload": _temp29,
  "odeBrackets": _temp30,
  "olor": _temp31,
  "ommentText": _temp32,
  "onfetti": _temp33,
  "onversationbubbles": _temp34,
  "rop": _temp35,
  "ursor": _temp36,
  "ut": _temp37,
  "ata": _temp38,
  "ataAnalytics": _temp39,
  "esktop": _temp40,
  "iamond": _temp41,
  "ocument": _temp42,
  "ownload": _temp43,
  "ropToUpload": _temp44,
  "ducation": _temp45,
  "ffects": _temp46,
  "moji": _temp47,
  "mptyStateExport": _temp48,
  "xplosion": _temp49,
  "xportTo": _temp50,
  "xposure": _temp51,
  "ileImage": _temp52,
  "ileShared": _temp53,
  "ileText": _temp54,
  "ileVideo": _temp55,
  "ileZip": _temp56,
  "ilmstrip": _temp57,
  "ilter": _temp58,
  "ilters": _temp59,
  "ireworks": _temp60,
  "lag": _temp61,
  "lagCheckmark": _temp62,
  "lagCross": _temp63,
  "olderClose": _temp64,
  "olderOpen": _temp65,
  "olderShared": _temp66,
  "earSetting": _temp67,
  "ift": _temp68,
  "lobe": _temp69,
  "lobeGrid": _temp70,
  "raphBarChart": _temp71
}